document.addEventListener('DOMContentLoaded', () => {
  const $helpbtn = document.querySelector("#js-helpBtn");
  const $helpblcok = document.querySelector(".p-helpBlock");
  let helpflag = true;

  if($helpblcok) {
    $helpblcok.addEventListener("click", () => {
      if(helpflag == true) {
        $helpblcok.classList.add("is-active");
        helpflag = false;
      } else {
        $helpblcok.classList.remove("is-active");
        helpflag = true;
      }
    }, false);
  }

  const $ProductChangeButton = document.querySelectorAll(".Product__SlideshowNavArrow");
  const $ProductChangeButtonPrev = document.querySelector(".Product__SlideshowNavArrow--previous");
  const $ProductChangeButtonNext = document.querySelector(".Product__SlideshowNavArrow--next");
  const $Dots = document.querySelector(".flickity-page-dots");
  const $Dot = $Dots.querySelectorAll(".dot");
  let $Current = $Dots.querySelector(".is-selected");
  let $CurrentNum = $Current.getAttribute('data-index');

  const $ProductChangeThumBtn = document.querySelectorAll(".Product__ThumbnailArrow");
  const $ProductChangeThumBtnPrev = document.querySelector('.Thum-prev');
  const $ProductChangeThumBtnNext = document.querySelector('.Thum-next');


  if($CurrentNum == 0) {
    $ProductChangeButtonPrev.style.opacity = 0.3;
    $ProductChangeThumBtnPrev.style.opacity = 0.3;
  } else if($CurrentNum == $Dot.length-1) {
    $ProductChangeButtonNext.style.opacity = 0.3;
    $ProductChangeThumBtnNext.style.opacity = 0.3;
  } else {
    $ProductChangeButton[i].style.opacity = 1;
    $ProductChangeThumBtn[i].style.opacity = 0.8;
  }

  for (let i = 0; i < $ProductChangeThumBtn.length; i++) {
    $ProductChangeThumBtn[i].addEventListener("click", function(){
      setTimeout(function(){
        $Current = $Dots.querySelector(".is-selected");
        $CurrentNum = $Current.getAttribute('data-index');
        if($CurrentNum == 0) {
          $ProductChangeThumBtnPrev.style.opacity = 0.3;
        } else {
          $ProductChangeThumBtnPrev.style.opacity = 0.8;
        }
        if($CurrentNum == $Dot.length-1) {
          $ProductChangeThumBtnNext.style.opacity = 0.3;
        } else {
          $ProductChangeThumBtnNext.style.opacity = 0.8;
        }
      }, 100)
    });
  }

  for (let i = 0; i < $ProductChangeButton.length; i++) {
    $ProductChangeButton[i].addEventListener("click", function(){
      setTimeout(function(){
        $Current = $Dots.querySelector(".is-selected");
        $CurrentNum = $Current.getAttribute('data-index');
        if($CurrentNum == 0) {
          $ProductChangeButtonPrev.style.opacity = 0.3;
        } else {
          $ProductChangeButtonPrev.style.opacity = 1;
        }
        if($CurrentNum == $Dot.length-1) {
          $ProductChangeButtonNext.style.opacity = 0.3;
        } else {
          $ProductChangeButtonNext.style.opacity = 1;
        }
      }, 100)
    });
  }
}, false);